import * as $ from 'jquery';
import 'bootstrap';
import 'flipclock';
import * as moment from 'moment';

export class countdownTimer{
	$countdowntimer: any = $('.countdown-timer--container');
	countdown(): any{
		let _self = this;
		let $clockCounter:any = [];
		_self.$countdowntimer.each(function(){
			//Get Promo end date & time
			let $timerInstance = $(this);
			let $getCountDownTime: any = $timerInstance.attr('data-counttime');
			let $getCountDownTimeMoment:any  = new Date($getCountDownTime).getTime() / 1000;
			let $getCountDownTimeSeconds:any = $getCountDownTimeMoment;

			//Get User current date & time
			let $getUserTime: any = new Date();
			let $getUserTimeMomentSeconds:any = $getUserTime/1000;

			let $getRemainTime: any = $getCountDownTimeSeconds - $getUserTimeMomentSeconds;

			var $countTimer = $timerInstance.find('.countdown-flipclock').FlipClock($getRemainTime, {
					countdown: true,
					callbacks: {
							stop: function() {
									// Do whatever you want to do here,
									// that may include hiding the clock
									// or displaying the image you mentioned
									$('.message').html('The clock has stopped!');
									$timerInstance.hide();
							}
					}
			});
			$clockCounter.push($countTimer);
		});
	}
}

let scope:Element = document.querySelector('.countdown-timer--container');
if (scope){
	try {
	let countdowntimer = new countdownTimer();
			countdowntimer.countdown();
	} catch(e) {console.error(e);}
}
